<template>
  <div class="d-flex flex-column align-items-end">
    <multiselect v-if="showUGSelector" v-model="selectedUG" open-direction="bottom" @input="onInputUG"
      @select="onSelectedUG" :close-on-select="true" :searchable="true" label="Nome" :show-labels="false"
      deselect-label="" :allow-empty="false" placeholder="Selecione uma UG" track-by="Codigo" :options="optionsUG">
      <template slot="noOptions">
        <small><i>Erro ao obter dados.</i></small>
      </template>
      <template slot="noResult">
        <i>Sem resultados.</i>
      </template>
    </multiselect>
    <span v-if="gestor" class="span-gestor">
      <span class="font-weight-bold">Gestor: </span>
      {{ gestor }}
    </span>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect"
import { store, trackUgChangeConfirmed, trackUgChangeFailed, trackUgChangeRequested, updateToken } from "@/store"
import { limparStoreUG } from "@/stores/StoreProtocolosProcessos"
import ugService from "@/services/administracao/ugService"
import usuarioService from "@/services/administracao/usuarioService"
import AlertCP from '@/components/AlertCP.vue'
import { UtilsTS } from '@/utilsts'

export default {
  name: "UGSelector",
  components: {
    Multiselect,
  },
  mixins: [UtilsTS],
  data() {
    return {
      selectedUG: "",
      preSelectedUG: "",
      optionsUG: [],
    };
  },
  computed: {
    gestor() {
      return store.gestorUG
    },
    showUGSelector() {
      return store.showUGSelector;
    }
  },
  methods: {
    onSelectedUG() {
      this.preSelectedUG = this.selectedUG
    },

    async onInputUG() {
      const previousCodigoUg = store.codigoUG || null
      const nextCodigoUg = this.selectedUG && this.selectedUG.Codigo ? this.selectedUG.Codigo : null
      if (nextCodigoUg) trackUgChangeRequested(nextCodigoUg, previousCodigoUg)

      try {
        const loginData = await this.doLoginUG();
        await updateToken(
          loginData.token,
          loginData.cpf,
          loginData.codigoUg,
          loginData.nomeUsuario,
          loginData.primeiroAcesso,
          loginData.permissoes,
          loginData.nomeGestor,
          null,
          '',
          loginData.idUsuario ?? store.idUsuario
        )
        trackUgChangeConfirmed(loginData.codigoUg, previousCodigoUg)
        limparStoreUG()
        this.selectedUG = this.optionsUG.find((c) => c.Codigo === loginData.codigoUg)
        if (this.$router.history.current.name != 'inicio')
          this.$router.push("/inicio")
        //this.loadCPAlert();
        const cpAlertData = await this.loadCPAlert();
        if (cpAlertData && cpAlertData.mostrarAlertaCP) {
          this.$toast.error(<AlertCP diligenciasNaoLidas={cpAlertData.qtdDiligenciasNaoLidas}
            diligenciasNaoRespondidas={cpAlertData.qtdDiligenciasNaoRespondidas}
            citacoesNaoLidas={cpAlertData.qtdCitacoesNaoLidas}
            citacoesNaoRespondidas={cpAlertData.qtdCitacoesNaoRespondidas}
            avisosNaoLidos={cpAlertData.qtdAvisos}
            assinaturasPendentes={cpAlertData.qtdSolicitacoesAssinatura}
            intimacoesNaoLidas={cpAlertData.qtdIntimacoesNaoLidas}
            intimacoesNaoRespondidas={cpAlertData.qtdIntimacoesNaoRespondidas}
            avisosComRespostaNaoLidas={cpAlertData.qtdAvisosComRespostaNaoLidas}
            avisosComRespostaNaoRespondidas={cpAlertData.qtdAvisosComRespostaNaoRespondidas}
            oficiosNaoLidas={cpAlertData.qtdOficiosNaoLidas}
            oficiosNaoRespondidas={cpAlertData.qtdOficiosNaoRespondidas}
            determinacoesNaoLidas={cpAlertData.qtdDeterminacoesNaoLidas}
            determinacoesNaoRespondidas={cpAlertData.qtdDeterminacoesNaoRespondidas}
            tagsNaoLidas={cpAlertData.qtdTermosDeAjustamentoDeGestaoNaoLidas}
            tagsNaoRespondidas={cpAlertData.qtdTermosDeAjustamentoDeGestaoNaoRespondidas}
            cautelaresNaoLidas={cpAlertData.qtdCautelaresNaoLidas}
            cautelaresNaoRespondidas={cpAlertData.qtdCautelaresNaoRespondidas}
          />, {
            timeout: 20000,
          })
        }
      } catch (error) {
        if (nextCodigoUg) trackUgChangeFailed(nextCodigoUg, previousCodigoUg)
        this.$toast.error("Falha ao tentar entrar na UG. Por favor tente novamente")
        store.blockScreen = false
        if (process.env.NODE_ENV !== 'development')
          this.selectedUG = this.preSelectedUG
      }
      finally {
        store.blockScreen = false
      }
    },
    doLoginUG() {
      store.blockScreen = true
      return usuarioService.loginUg(this.selectedUG.Codigo)
    },
    async obterUgsUsuario() {
      try {
        const response = await ugService.obterUgsUsuario()
        if (response && response.status === 200) {
          this.optionsUG = this.formatedUGLabels(response.data)
          if (this.optionsUG.length < 1 || (store.primeiroAcesso == "S"))
            store.showUGSelector = false;
        } else {
          throw new Error(response.data && response.data.msg ? response.data.msg : 'Ocorreu um erro ao buscar UGs ativas!')
        }
      } catch (e) {
        console.error(e)
        this.$toast.error(e.message ? e.message : e);
      } finally {
        this.isBusy = false
      }
    },
    atualizarUGSelecionada() {
      if (store.codigoUG) {
        this.selectedUG = this.optionsUG.find((c) => c.Codigo === store.codigoUG);
      }
    },
  },
  async mounted() {
    await this.obterUgsUsuario();
    this.atualizarUGSelecionada()
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#ug-select {
  display: inline-block;
  padding-top: 2rem !important;
  flex: 0 0 30% !important;
  max-width: 30% !important;
}

.multiselect {
  display: inline-block;
  width: calc(100% - 80px);
}

.multiselect__tags {
  border: var(--baseColor) solid 1px !important;
  border-radius: 3px !important;
  overflow: hidden;
  min-height: 42px !important;
}

.multiselect__option--selected {
  color: var(--baseColor) !important;
}

.multiselect__content-wrapper {
  border: 1px solid var(--baseColor) !important;
}

span.multiselect__single {
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 0px !important;
}

.multiselect__option--highlight {
  background: var(--baseColor) !important;
  color: #fff !important;
}

.multiselect__input,
.multiselect__single {
  padding-top: 4px;
  background-color: #fff !important;
  color: var(--baseColor) !important;
}

.multiselect__input::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: var(--baseColor) !important;
}

.multiselect__input::active {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  border: none;
}

.multiselect__tags {
  background-color: #fff;
  color: var(--baseColor) !important;
  border-radius: 2px;
}

.multiselect__select:before {
  color: var(--baseColor) !important;
  border-color: var(--baseColor) transparent transparent !important;
}

.multiselect--active {
  z-index: 999999;
}

.multiselect__placeholder {
  padding-top: 2px !important;
  margin-bottom: 6px !important;
  padding-left: 5px;
  color: var(--baseColor) !important;
  font-weight: 400;
  font-size: 1rem;
}

.multiselect__single {
  cursor: pointer;
}

.multiselect__input,
.multiselect__single {
  vertical-align: initial;
}

.span-gestor {
  color: var(--baseColor) !important;
}
</style>
